/** Deposit pay page (17 October 2026): what is asked, and a card payment on the clinic's account. */
import type { PayIntentResponse, PayPageResponse } from "@wapadesk/schema";
import { BookApi } from "./book-api";

export class PayApi extends BookApi {
  page(token: string): Promise<PayPageResponse> {
    return this.call("GET", `/v1/widget/pay/${encodeURIComponent(token)}`);
  }
  intent(token: string): Promise<PayIntentResponse> {
    return this.call("POST", `/v1/widget/pay/${encodeURIComponent(token)}/intent`, {});
  }
}
